import axios from '../axios'
import { formatSelectOption as format } from '@/utils'
const cache = {}

/** 门店管理 */

/**
 * 门店筛选框
 */
export const dealerSelects = () => axios.post('/jkd/admin/dealersFilter', null, { loading: 'dealerfilter' }).then(({ data = {} }) => {
  const {
    netForm,
    authorizeNet,
    authorizeType,
    status
  } = data.data || {}
  return {
    net_form: format(netForm, 'name', 'name'),
    authorize_net: format(authorizeNet, 'name', 'name'),
    authorize_type: format(authorizeType, 'name', 'name'),
    status: format(status)
  }
})

/**
 * 客服、市场、销售战区
 */
export const dealerDaquList = () => axios.post('/jkd/admin/daquListGroupByBusiness', null, { loading: 'dealerdaqu' }).then(({ data = {} }) => {
  const { kefu, shichang, xiaoshou } = data.data || {}
  return {
    kefu_daqu_id: format(kefu),
    shichang_daqu_id: format(shichang),
    xiaoshou_daqu_id: format(xiaoshou)
  }
})

/**
 * 客服、市场、销售小区
 */
export const dealerXiaoquList = data => axios.post('/jkd/admin/xiaoquListGroupByBusiness', data, { loading: 'dealerxiaoqu' }).then(({ data = {} }) => {
  const {
    kefu_xiaoqus,
    shichang_xiaoqus,
    xiaoshou_xiaoqus
  } = data.data || {}
  return {
    kefu_xiaoqu_id: format(kefu_xiaoqus),
    shichang_xiaoqu_id: format(shichang_xiaoqus),
    xiaoshou_xiaoqu_id: format(xiaoshou_xiaoqus)
  }
})

cache.kefu = {}
export const getKefuXiaoqu = id => {
  if (!id) return Promise.resolve([])
  if (cache.kefu[id]) return cache.kefu[id]
  return (cache.kefu[id] = dealerXiaoquList({ kefu_daqu_id: id }).then(data => data.kefu_xiaoqu_id, () => (cache.kefu[id] = null)))
}

cache.shichang = {}
export const getShichangXiaoqu = id => {
  if (!id) return Promise.resolve([])
  if (cache.shichang[id]) return cache.shichang[id]
  return (cache.shichang[id] = dealerXiaoquList({ shichang_daqu_id: id }).then(data => data.shichang_xiaoqu_id, () => (cache.shichang[id] = null)))
}

cache.xiaoshou = {}
export const getXiaoshouXiaoqu = id => {
  if (!id) return Promise.resolve([])
  if (cache.xiaoshou[id]) return cache.xiaoshou[id]
  return (cache.xiaoshou[id] = dealerXiaoquList({ xiaoshou_daqu_id: id }).then(data => data.xiaoshou_xiaoqu_id, () => (cache.xiaoshou[id] = null)))
}

/**
 * 门店新增
 */
export const addDealer = data => axios.post('/jkd/admin/addDealer', data, { loading: 'adddealer' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 门店编辑
 */
export const modifyDealer = data => axios.post('/jkd/admin/changeDealer', data, { loading: 'modifydealer' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 门店列表
 */
export const dealerList = data => axios.post('/jkd/admin/dealers', data, { loading: 'loading' }).then(({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  return { list, total }
})

export default {
  dealerSelects,
  dealerDaquList,
  dealerXiaoquList,
  getKefuXiaoqu,
  getShichangXiaoqu,
  getXiaoshouXiaoqu,
  addDealer,
  modifyDealer,
  dealerList
}
